export const frontmatter = {
  title: "Whitelisting",
  order: 10,
}

## Whitelisting

We offer bespoke services for established projects. Any token that meets the whitelisting guidelines can request it.

There are 3 types of whitelistings offered on Scale.farm:

- Soft Listing
- Full Listing
- Decentralized Listing

## Soft Listing

### Requirements

- Contract must be verified.
- Active social presence and community engagement.
- The liquidity pool must have at least $10,000 worth of total liquidity on its Scale.farm Pairs.
- Tokens applying for a whitelist must be paired against ETH, stablecoins, or our native token, SCALE.
- Project applying must be 10 days old or more!
- Requested asset must have more than 25 holders.
- Holder distribution must not be skewed.
- Total cumulative Traded Volume over the last 30 days must be more than $25,000.
- Total cumulative Trade Fees over the last 30 days must be more than $250.

### Perks

- [x] Token's Logo will be added to the Swap Page for easy trading
- [x] Access to technical assistance from our Team!

## Full Listing

### Requirements

- Contract must be verified.
- Active social presence and community engagement.
- The liquidity pool must have at least **$25,000** worth of total **liquidity on Scale.farm**.
- Tokens applying for a whitelist must be paired against ETH, stablecoins, or our native token, SCALE.
- Project applying must be 1 Month old or more!
- Requested asset must have more than 100 holders.
- Holder distribution must not be skewed.
- Total cumulative Traded **Volume** over the last **7 days** must be more than **$25,000**.
- Total cumulative Trade **Fees** over the last **7 days** must be more than **$250**.

### Perks

- [x] Token's Logo will be added to the Swap Page for easy trading
- [x] Addition to our official Token List.
- [x] Access to technical assistance from our Team!
- [x] Subscription to our Marketing program!
- [x] Gauge Creation for Farming!
- [x] Ability to Bribe for Emissions!
- [x] Eligible for up to 10% of Votes each week!

## _Decentralized Listing: Coming Soon™_

### Requirements

- Tokens applying for a whitelist must be paired against ETH, stablecoins, or our native token, SCALE.
- Lock or Burn X SCALE.
- No other requirements

### Perks

- [ ] Instant Gauge Creation for Farming!
- [ ] Ability to Bribe for Emissions!
- [ ] Eligible for up to 0.1% of Votes each week!
